module.exports = __webpack_public_path__ + "static/media/carousel-9.ee857e2d.jpg";